export default "__VITE_ASSET__CL0uBt5Q__"